@if (project) {
  <div class="fx-layout-row fx-align--x-center fx-gap--16px fx-gap--4px--xs fx-align--space-between-x">
    @if (project.primaryProduct === 'SAMPLE') {
      <div class="samples-heading">
        <h1>Product Samples</h1>
        <i>Individual Samples are $1 each and receive a coupon credit for up to <strong>$20 off</strong> your next non-sample purchase!</i>
      </div>
    }
    <div class="action-bar fx-layout-row fx-align--x-center fx-gap--16px fx-gap--4px--xs fx-align--space-between-x">
      <div class="current-price fx-layout-row fx-gap--32px--lt-lg fx-gap--32px--gt-md">
        <div>
          <div class="heading">Count</div>
          <div>
            <!--
            <input id="suggestion-qty" class="rounded" type="number" mbnmQty [(ngModel)]="project.qty" (keyup)="updateExamplePrices()" [matAutocomplete]="qtyAuto"/>
            <mat-autocomplete #qtyAuto="matAutocomplete" panelWidth="280px">
              <mat-option [disabled]="true" class="heading">
                Volume Discounts Available
              </mat-option>
              @for (option of options; track option) {
                <mat-option class="qty-options" [value]="option.qty">
                  <span class="sm">buy </span>
                  <strong>{{option.qty}}</strong>
                  <span class="sm"> and save </span>
                  <strong class="green">{{ option.savings | percent:'1.0-0' }}</strong>
                </mat-option>
              }
            </mat-autocomplete>
            -->
            @if (project.primaryProduct === 'SAMPLE') {
              <span class="sample-count">{{project.numSamples}}</span>
            }
            @if (project.primaryProduct !== 'SAMPLE') {
              <input id="no-suggestion-qty" class="rounded" type="number" min="1" mbnmQty [(ngModel)]="project.qty" />
            }
          </div>
        </div>
        @if (completionText) {
          <div>
            <span class="tiny-text" [innerHtml]="completionText"></span>
          </div>
        }
        @else {
          @if (project.primaryProduct !== 'SAMPLE') {
            <div>
              <div class="heading">
                Each
                @if (project.primaryProduct !== 'SAMPLE') {
                  <mat-icon
                    (click)="unitPriceInfoClicked()" svgIcon="information-outline">
                  </mat-icon>
                }
              </div>
              <div class="unit-price" [ngClass]="{faded: project.longUpdate}">
                @if (project.qty > 0 && !project.size.incomplete) {
                  @if (project.price < project.maxPrice) {
                    <s [innerHtml]="project.maxPrice | currency2"></s>
                  }
                  <span class="currency" [innerHtml]="project?.price | currency2"></span>
                  @if (project.price < project.maxPrice) {
                    <span class="savings">
                      You Save {{(1 - project.price / project.maxPrice) | percent:'1.0-0'}}
                      <!--<br />
                      <strong [innerHtml]="project.qty * (project.maxPrice - project.price) | currency2"></strong> Overall!-->
                    </span>
                  }
                }
                @if (project.primaryProduct !== 'SAMPLE' && project.qty > 1) {
                  <div class="hide-gt-md" >
                    (<span class="currency small" [innerHtml]="project.qty * project.price | currency2" [ngClass]="{faded: project.longUpdate}"></span> total)
                  </div>
                }
                @if (project.longUpdate) {
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                }
              </div>
            </div>
          }
          <div class="hide-lt-lg">
            <div class="heading">
              @if (project.primaryProduct === 'SAMPLE') {
                Total Price
              }
              @if (project.primaryProduct !== 'SAMPLE') {
                Total
              }
            </div>
            <div>
              @if (project.primaryProduct === 'SAMPLE') {
                <span class="currency" [innerHtml]="project.numSamples * project.price | currency2"></span>
              }
              @if (project.primaryProduct !== 'SAMPLE') {
                <span class="currency" [innerHtml]="project.qty * project.price | currency2" [ngClass]="{faded: project.longUpdate}"></span>
              }
            </div>
          </div>
        }
        @if (project.primaryProduct === 'SAMPLE') {
          <div>
            <div class="heading">
              @if (project.primaryProduct === 'SAMPLE') {
                Total Price
              }
            </div>
            <div>
              @if (project.primaryProduct === 'SAMPLE') {
                <span class="currency" [innerHtml]="project.numSamples * project.price | currency2"></span>
              }
            </div>
          </div>
        }
      </div>
      <div class="action-btn">
        <button mat-flat-button color="primary" (click)="addToCartClicked($event)" [disabled]="canDisableAddToCart && project.updating">
          <span>
            {{project.originalId ? 'Save Changes' : 'Add to ' + (currentCartIsOrder ? 'Order' : 'Cart')}}
          </span>
        </button>
        @if (project.originalId) {
          <a class="cancel-edit" (click)="cancelEditClicked()">
            cancel edit
          </a>
        }
      </div>
    </div>
  </div>
}
